// src/pages/Login.jsx
import React from "react";
import { MDBContainer, MDBCol, MDBRow, MDBBtn } from "mdb-react-ui-kit";
import IconAnalitic from "../img/Logo-ICON-Analytics-Icontec.png";
import imgMicrosoft from "../img/logoms_660-660x432.jpg";
import { AuthAzure } from "../Services/Rest";
import Cookies from "universal-cookie";

function Login() {
  const cookie = new Cookies();
  const postIcontec = (e) => {
    e.preventDefault();
    // Redirige al endpoint que inicia autenticación en Azure (backend)
    window.location.href = AuthAzure;
    // No llamamos a .then ni recargas adicionales: backend debe redirigir a frontend con token
  };

  return (
    <MDBContainer fluid className="p-3 my-5 h-custom">
      <MDBRow>
        <MDBCol col="12" md="12">
          <img
            src={IconAnalitic}
            className="img-fluid"
            alt="Logo"
            width={600}
          />
          <div className="d-flex flex-row align-items-center justify-content-center">
            <p className="lead fw-normal mb-0 me-3">
              Autenticación con Microsoft
            </p>
          </div>
          <div className="divider d-flex align-items-center my-4">
            <img
              src={imgMicrosoft}
              className="img-fluid"
              alt="Microsoft"
              width={120}
            />
          </div>
          <div className="text-center text-md-start mt-4 pt-2">
            <MDBBtn className="mb-0 px-5" size="lg" onClick={postIcontec}>
              Acceder
            </MDBBtn>
            {cookie.get("tipo")}
          </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default Login;
